/** Padded surfaces: a 2px border 1px inside the box, so the box never grows. */
export const MESSAGE_INSET_FOCUS_BORDER_CLASS =
  "relative focus-visible:outline-none focus-visible:after:pointer-events-none focus-visible:after:absolute focus-visible:after:inset-px focus-visible:after:rounded-[inherit] focus-visible:after:border-2 focus-visible:after:border-[var(--focus-border)] focus-visible:after:content-['']";

/** Same border, drawn on a frame whose focusable row is a child (see ArtifactSummaryCard's preview layout). */
export const MESSAGE_INSET_FOCUS_WITHIN_BORDER_CLASS =
  "relative has-[:focus-visible]:after:pointer-events-none has-[:focus-visible]:after:absolute has-[:focus-visible]:after:inset-px has-[:focus-visible]:after:z-10 has-[:focus-visible]:after:rounded-[inherit] has-[:focus-visible]:after:border-2 has-[:focus-visible]:after:border-[var(--focus-border)] has-[:focus-visible]:after:content-['']";

/** Selected padded bubbles: the accent border stays 1px inside the clipped row. */
export const MESSAGE_SELECTED_BORDER_CLASS =
  "relative rounded-lg after:pointer-events-none after:absolute after:inset-px after:rounded-[7px] after:border-2 after:border-[var(--focus-border)] after:content-['']";

/** Selected unpadded text: the border sits in TRANSCRIPT_ROW_INSET_CLASS's 3px gutter so it never covers edge-flush glyphs. */
export const MESSAGE_SELECTED_OUTSET_BORDER_CLASS =
  "relative after:pointer-events-none after:absolute after:-inset-x-[3px] after:inset-y-px after:rounded-[11px] after:border-2 after:border-[var(--focus-border)] after:content-['']";

/** Unpadded text: a 2px outline 1px outside the box; needs 3px of unclipped room. */
export const MESSAGE_OUTSET_FOCUS_BORDER_CLASS =
  "outline outline-0 outline-offset-1 outline-transparent focus-visible:outline-2 focus-visible:outline-[var(--focus-border)]";

/**
 * The transcript row clips at its box (content-visibility), so it widens by
 * 3px on each side, never vertically, to give edge-flush borders room.
 */
export const TRANSCRIPT_ROW_INSET_CLASS = "-mx-[3px] px-[3px]";
